import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles.css'
import omit from 'lodash/omit'
import uniq from 'lodash/uniq'
import autobind from 'autobind-decorator'
import FaSearch from 'react-icons/lib/fa/search'

const keys = {
  ENTER: 13,
  TAB: 9,
  BACKSPACE: 8,
  UP_ARROW: 38,
  DOWN_ARROW: 40,
  ESCAPE: 27
}

export default class TagsField extends React.Component {
  static propTypes = {
    value: PropTypes.object,
    onChange: PropTypes.func
  }

  state = {}

  @autobind
  deleteTag(i) {
    const tags = this.props.value.tags || []
    tags.splice(i, 1)
    this.props.onChange({
      tags,
      ...omit(this.props.value, 'tags')
    })
  }

  @autobind
  addTag(tag) {
    let tags = this.props.value.tags || []
    if (tags.length >= 3) {
      return
    }
    tags.push(tag)
    tags = uniq(tags)
    this.props.onChange({
      tags,
      filter: ''
    })
  }

  @autobind
  handleKeyDown(e) {
    if ((e.keyCode === keys.TAB || e.keyCode === keys.ENTER) && this.refs.input.value !== '') {
      e.preventDefault()
      this.addTag(this.refs.input.value)
      this.refs.input.value = ''
    }
    if (e.keyCode === keys.BACKSPACE && this.refs.input.value === '') {
      this.deleteTag(this.props.value.tags.length - 1)
    }
  }

  renderTags() {
    const tags = this.props.value.tags || []
    return tags.map((tag, index) => {
      return (
        <div className={styles.tag} key={index}>
          <span className={styles.tagText}>{tag}</span>
          <a onClick={() => this.deleteTag(index)} className={styles.deleteTag}>
            ×
          </a>
        </div>
      )
    })
  }

  render() {
    return (
      <div className={styles.container}>
        {this.renderTags()}
        <input
          className={styles.input}
          ref="input"
          onChange={event =>
            this.props.onChange({filter: event.target.value, ...omit(this.props.value, 'filter')})}
          value={this.props.value.filter}
          onKeyDown={this.handleKeyDown}
          style={{width: '100%'}}
          type="text"
          placeholder='Buscar documento por nombre, emails o tags'
        />
        <div className='iconSearch'><FaSearch/></div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/components/fields/TagsFilter/TagsField.js